import React from 'react'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import { prepareData } from 'utils/googleData'

export default function ProvenApproach(props) {
  const {
    enable,
    provenApproachTitle,
    subtitle,
    features,
    backgroundColor = 'bg-[#0B1C39]',
  } = prepareData({ props })
  
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

  return (
    <section className={`py-24 px-5 ${backgroundColor}`}>
      <div className="max-w-7xl mx-auto">
        {/* Title Section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-white"
            dangerouslySetInnerHTML={{ __html: provenApproachTitle.title }}>
          </h2>
          <p className="text-lg lg:text-xl text-gray-200 max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features?.map((feature) => {
            const { icon, name, description, style = '' } = feature
            const Icon = NotProductIcons[icon] || ProductIcons[icon]

            return (
              <div
                key={name}
                className="bg-[#1B3154] rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  {Icon && (
                    <div className="w-20 h-20 mb-6 rounded-full bg-[#2C4268] flex items-center justify-center ring-4 ring-[#1B3154]/50">
                      <Icon className={`w-10 h-10 text-[#4BB3FD] ${style}`} />
                    </div>
                  )}
                  <h3 className="text-2xl font-bold mb-4 text-white">
                    {name}
                  </h3>
                  <p className="text-[#E5E7EB] text-base leading-relaxed max-w-md">
                    {description}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
